import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProactiveSupportDevicesRoute: InvariantJiraRoute = {
	name: 'servicedesk-proactive-support-devices',
	path: '/jira/servicedesk/projects/:projectKey/proactive-support/devices',
	exact: true,
};
